"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/breadcrumbs.css");
/**
 * A breadcrumb trail is used as a navigational aid to help users keep track
 * of their place in the application. It is often placed before a page's main content.
 *
 * Breadcrumb items can use `Button` or `a` or any custom component (passed as `children`).
 *
 * For accessibility, make sure to provide an aria-label describing the type of navigation.
 *
 * @example
 * <Breadcrumbs aria-label='Primary'>
 *   <Button onClick={() => {}}>Root</Button>
 *   <Button onClick={() => {}}>Item 1</Button>
 *   <Button onClick={() => {}}>Item 2</Button>
 * </Breadcrumbs>
 *
 * @example
 * <Breadcrumbs aria-label='Secondary'>
 *   <a href='/'>Root</a>
 *   <a href='/level1/'>Level 1</a>
 *   <span>Current level</span>
 * </Breadcrumbs>
 */
exports.Breadcrumbs = React.forwardRef((props, ref) => {
    const { children: items, currentIndex = items.length - 1, separator, overflowButton, className, ...rest } = props;
    (0, index_js_1.useTheme)();
    const [overflowRef, visibleCount] = (0, index_js_1.useOverflow)(items);
    const refs = (0, index_js_1.useMergedRefs)(overflowRef, ref);
    return (React.createElement("nav", { className: (0, classnames_1.default)('iui-breadcrumbs', className), ref: refs, "aria-label": 'Breadcrumb', ...rest },
        React.createElement("ol", { className: 'iui-breadcrumbs-list' },
            visibleCount > 1 && (React.createElement(React.Fragment, null,
                React.createElement(ListItem, { item: items[0], isActive: currentIndex === 0 }),
                React.createElement(Separator, { separator: separator }))),
            items.length - visibleCount > 0 && (React.createElement(React.Fragment, null,
                React.createElement("li", { className: 'iui-breadcrumbs-item iui-breadcrumbs-item-overrides' }, overflowButton ? (overflowButton(visibleCount)) : (React.createElement("span", { className: 'iui-breadcrumbs-text' }, "\u2026"))),
                React.createElement(Separator, { separator: separator }))),
            items
                .slice(visibleCount > 1
                ? items.length - visibleCount + 1
                : items.length - 1)
                .map((_, _index) => {
                const index = visibleCount > 1
                    ? 1 + (items.length - visibleCount) + _index
                    : items.length - 1;
                return (React.createElement(React.Fragment, { key: index },
                    React.createElement(ListItem, { item: items[index], isActive: currentIndex === index }),
                    index < items.length - 1 && (React.createElement(Separator, { separator: separator }))));
            }))));
});
const ListItem = ({ item, isActive, }) => {
    var _a;
    return (React.createElement("li", { className: 'iui-breadcrumbs-item iui-breadcrumbs-item-overrides' }, React.isValidElement(item)
        ? React.cloneElement(item, {
            'aria-current': ((_a = item.props['aria-current']) !== null && _a !== void 0 ? _a : isActive) ? 'location' : undefined,
        })
        : item));
};
const Separator = ({ separator }) => (React.createElement("li", { className: 'iui-breadcrumbs-separator', "aria-hidden": true }, separator !== null && separator !== void 0 ? separator : React.createElement(index_js_1.SvgChevronRight, null)));
exports.default = exports.Breadcrumbs;
